/**
 * Created by mzietek on 2017-03-14.
 */

(function(){

    angular
        .module('repairforms.directive.module')
        .directive('validateMaxValue', validateMaxValue);

    validateMaxValue.$inject = ['FormInputPossibleErrors']

    function validateMaxValue (FormInputPossibleErrors) {
        return {
            require: 'ngModel',
            link: function (scope, element, attrs, ctrl) {

                var minVal = attrs.validateMaxValue;
                var errors = FormInputPossibleErrors.getPossibleErrors();

                ctrl.$validators[errors.MAXVALUE] = checkIfValueNotHigher;

                function checkIfValueNotHigher(value) {
                    if(attrs.required) {
                        return !isNaN(value) && !isNaN(attrs.validateMaxValue) && attrs.required && Number(value) <= Number(attrs.validateMaxValue);
                    }
                    return true;
                };
            }
        };
    }

})();